import { sendApiAIRequest } from "../../api/api";

const BASE = "/api/rawData/recommended-prompts";
const FULL_BASE = "/api/rawData/full-recommended-prompts";
const FOLDERS_BASE = "/api/rawData/recommended-prompt-folders";

const unwrap = (res) => {
  if (!res || res.status >= 400) {
    const msg =
      res?.data?.msg ||
      res?.data?.message ||
      (res?.status === 403 ? "僅限管理者操作" : "請求失敗");
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }

  const body = res.data;
  if (!body || typeof body !== "object") {
    return null;
  }

  if (body.error) {
    const msg = body.msg || body.message || "請求失敗";
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }

  return body.data !== undefined ? body.data : body;
};

export const fetchRecommendedPrompts = async () => {
  const res = await sendApiAIRequest("GET", FULL_BASE);
  return unwrap(res);
};

export const fetchRecommendedPromptById = async (id) => {
  const res = await sendApiAIRequest("GET", `${BASE}/${id}`);
  return unwrap(res);
};

export const createRecommendedPrompt = async (payload) => {
  const res = await sendApiAIRequest("POST", BASE, payload);
  return unwrap(res);
};

export const updateRecommendedPrompt = async (id, payload) => {
  const res = await sendApiAIRequest("PUT", `${BASE}/${id}`, payload);
  return unwrap(res);
};

export const deleteRecommendedPrompt = async (id) => {
  const res = await sendApiAIRequest("DELETE", `${BASE}/${id}`);
  return unwrap(res);
};

export const reorderRecommendedPrompts = async (items) => {
  const res = await sendApiAIRequest("PUT", `${BASE}/reorder`, items);
  return unwrap(res);
};

export const fetchRecommendedPromptFolders = async () => {
  const res = await sendApiAIRequest("GET", FOLDERS_BASE);
  return unwrap(res);
};

export const createRecommendedPromptFolder = async (payload) => {
  const res = await sendApiAIRequest("POST", FOLDERS_BASE, payload);
  return unwrap(res);
};

export const renameRecommendedPromptFolder = async (id, payload) => {
  const res = await sendApiAIRequest("PATCH", `${FOLDERS_BASE}/${id}`, payload);
  return unwrap(res);
};

export const deleteRecommendedPromptFolder = async (id) => {
  const res = await sendApiAIRequest("DELETE", `${FOLDERS_BASE}/${id}`);
  return unwrap(res);
};

export const reorderRecommendedPromptFolders = async (items) => {
  const res = await sendApiAIRequest("PUT", `${FOLDERS_BASE}/reorder`, items);
  return unwrap(res);
};
